<div class="ws">
    <!-- Access denied — user has no marketing.AuthorizedUser rows (issue #916) -->
    <ng-container *ngIf="unauthorized">
        <div class="ws__denied" style="max-width: 560px; margin: 80px auto; padding: 32px; text-align: center;">
            <h2 style="margin-bottom: 12px;">Marketing access not granted</h2>
            <p style="color: #64748b; line-height: 1.6;">
                You don't have access to any company's Marketing Agent surfaces.
                If you need access for your work, ask the Marketing Agent admin
                to add you to the allow-list.
            </p>
        </div>
    </ng-container>

    <!-- Main shell — hidden when settings drawer is open (mirrors CMO Dashboard pattern) -->
    <ng-container *ngIf="!settingsOpen && !unauthorized">
        <mkt-ws-brand-stripe></mkt-ws-brand-stripe>

        <header class="ws__header">
            <div class="ws__header-row">
                <a class="ws__brand" (click)="setSection('home')">
                    <span class="ws__brand-mark">m</span>
                    <span class="ws__brand-text">Marketing Workspace</span>
                </a>

                <nav class="ws__topnav">
                    <button *ngFor="let tab of tabs"
                            class="ws__topnav-item"
                            [class.ws__topnav-item--active]="isTabActive(tab.key)"
                            (click)="setTab(tab.key)">
                        {{ tab.label }}
                    </button>
                </nav>

                <div class="ws__header-right">
                    <select [(ngModel)]="defaultCompanyId"
                            class="ws__company-select"
                            (ngModelChange)="onCompanyChange()">
                        <option value="" disabled>Select company</option>
                        <option *ngFor="let c of companies" [value]="c.ID">{{ c.Name }}</option>
                    </select>

                    <button class="ws__cog"
                            [class.ws__cog--active]="settingsOpen"
                            (click)="toggleSettings()"
                            title="Settings">
                        <i class="fa-solid fa-gear"></i>
                    </button>
                </div>
            </div>

            <!-- Sub-nav strip — appears only when current section's parent has children -->
            <div class="ws__subnav-row" *ngIf="currentSubnavRoutes.length > 0">
                <div class="ws__subnav-inner">
                    <button *ngFor="let r of currentSubnavRoutes"
                            class="ws__subnav-item"
                            [class.ws__subnav-item--active]="currentSectionPath === r.path"
                            (click)="setSection(r.path)">
                        <i class="fa-solid {{ r.icon || 'fa-circle' }}" *ngIf="r.icon"></i>
                        <span>{{ r.label }}</span>
                        <span class="ws__subnav-pill" *ngIf="r.phase && r.phase !== 'Phase 1'">{{ r.phase }}</span>
                    </button>
                </div>
            </div>
        </header>

        <main class="ws__main">
            <div class="ws__main-inner">
                <div *ngIf="isLoading" class="ws__loading">
                    <i class="fa-solid fa-spinner fa-spin"></i> Loading…
                </div>

                <ng-container *ngIf="!isLoading">
                    <ng-container *ngIf="currentComponent; else notFound">
                        <ng-container *ngComponentOutlet="currentComponent; inputs: sectionInputs"></ng-container>
                    </ng-container>
                    <ng-template #notFound>
                        <mkt-ws-coming-soon
                            title="Section not found"
                            body="No section is registered at this path. Check marketing-workspace.routes.ts.">
                        </mkt-ws-coming-soon>
                    </ng-template>
                </ng-container>
            </div>
        </main>

        <!-- CMO Support chat fab (only when shell visible) -->
        <mkt-cmo-support-chat
            *ngIf="defaultCompanyId"
            [companyId]="defaultCompanyId"
            [brandName]="brandConfig?.Get('BrandName') || ''">
        </mkt-cmo-support-chat>
    </ng-container>

    <!-- Settings drawer takes over the full surface when open (mirrors CMO Dashboard) -->
    <div class="ws__settings-loading" *ngIf="settingsOpen && !settingsLoaded">
        <i class="fa-solid fa-spinner fa-spin"></i> Loading settings…
    </div>
    <mkt-settings-drawer *ngIf="settingsOpen && settingsLoaded"
        [open]="settingsOpen"
        [brandConfig]="brandConfig"
        [strategy]="strategy"
        [strategyPillars]="strategyPillars"
        [contentPlan]="contentPlan"
        [contentPlanItems]="contentPlanItems"
        [channelConfigs]="channelConfigs"
        [contentTypes]="contentTypes"
        [socialPlatforms]="socialPlatforms"
        [integrations]="integrations"
        [companyIntegrations]="companyIntegrations"
        [contentFeeds]="contentFeeds"
        [contentTemplates]="contentTemplates"
        [saveStatus]="saveStatus"
        (openChange)="settingsOpen = $event"
        (saveBrandConfig)="saveBrandConfig()"
        (saveStrategy)="saveStrategy()"
        (savePillar)="savePillar($event)"
        (addPillar)="addPillar()"
        (deletePillar)="deletePillar($event)"
        (savePlanItem)="savePlanItem($event)"
        (saveChannelConfig)="saveChannelConfig($event)"
        (addChannelConfig)="addChannelConfig($event)"
        (deleteChannelConfig)="deleteChannelConfig($event)"
        (saveFeed)="saveFeed($event)"
        (saveTemplate)="saveTemplate($event)"
        (createTemplate)="createTemplate($event)"
        (addCompanyIntegration)="addCompanyIntegration($event)"
        (toggleCompanyIntegration)="toggleCompanyIntegration($event)"
        (deleteCompanyIntegration)="deleteCompanyIntegration($event)">
    </mkt-settings-drawer>
</div>
